import * as firebase from 'firebase/app';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs/Observable';
import { User } from '@firebase/auth-types';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthService {
  user$: Observable<firebase.User>;

  constructor(private router: Router, private fb: AngularFireAuth) {
    this.user$ = this.fb.authState;
  }

  login() {
    this.fb.auth
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(_ => {
        this.router.navigate([`/matches`]);
      })
      .catch(error => console.info('auth error', error));
  }

  logout() {
    this.fb.auth.signOut();
    this.router.navigate([`/home`]);
  }

  getCurrentUserId(): Observable<string> {
    const observer = new Subject<string>();

    this.user$.subscribe(u => {
      if (u) {
        observer.next(u.uid);
      }
    });

    return observer.asObservable();
  }
}
